import { render, staticRenderFns } from "./RegisterIndividual.vue?vue&type=template&id=4cf424af&scoped=true"
import script from "./RegisterIndividual.vue?vue&type=script&lang=js"
export * from "./RegisterIndividual.vue?vue&type=script&lang=js"
import style0 from "./RegisterIndividual.vue?vue&type=style&index=0&id=4cf424af&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf424af",
  null
  
)

export default component.exports